var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "m8.966 3.857.737-1.903A1.71 1.71 0 0 1 11.297.857h1.406a1.71 1.71 0 0 1 1.594 1.097l.738 1.903 2.502 1.44 2.023-.308a1.71 1.71 0 0 1 1.715.84l.685 1.2a1.715 1.715 0 0 1-.137 1.937l-1.251 1.594v2.88l1.285 1.594a1.71 1.71 0 0 1 .138 1.937l-.686 1.2a1.715 1.715 0 0 1-1.714.84l-2.023-.308-2.503 1.44-.737 1.903a1.71 1.71 0 0 1-1.595 1.097h-1.44a1.71 1.71 0 0 1-1.594-1.097l-.737-1.903-2.503-1.44-2.023.309a1.715 1.715 0 0 1-1.714-.84l-.686-1.2a1.71 1.71 0 0 1 .137-1.938L3.43 13.44v-2.88L2.143 8.966a1.71 1.71 0 0 1-.137-1.937l.686-1.2a1.71 1.71 0 0 1 1.714-.84l2.023.308zM8.572 12a3.428 3.428 0 1 0 6.857 0 3.428 3.428 0 0 0-6.857 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSettings;